import { getRecipientGroup } from "src/api/contractSweepRecipientSetting";
import PageConfigProvider from "src/features/PageConfigProvider";
import ViewFilterTable from "./ViewFilterTable";
import { initFields } from "./types/FilterFields";
import useGetListParams from "./hooks/useGetListParams";

const ContractSweepRecipientGroup = () => {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix="contractSweepRecipientSetting"
      initFields={initFields}
      getTableDataApiFunc={getRecipientGroup}
      getListParams={getListParams}>
      <ViewFilterTable />
    </PageConfigProvider>
  );
};

export default ContractSweepRecipientGroup;
